import { useEffect } from "react";
import CategoryDetailTemplate from "../../../Templetes/Categories/Details/CategoryDetail.template";

const FollowlinePage = () => {
  useEffect(() => {
    document.title = "We Do Challenge - Line Follower Challenge";
  }, []);
  return <CategoryDetailTemplate />;
};

export default FollowlinePage;
